import actions from "./actions";
import { setRequestReducer, setSuccessReducer } from "../helper";
// import dayjs from 'dayjs';

// const initDate = dayjs().subtract(1, 'month').endOf('month');

const initState = {
    payrollImportState: false,
    payroll: {
        payroll_file: null,
        payroll_switch: false,
        payroll_date: null,
        salary_switch: false,
        salary_date: null,
        salary_account_id: null,
        kwsp_switch: false,
        kwsp_date: null,
        kwsp_contact_id: null,
        kwsp_account_id: null,
        socso_switch: false,
        socso_date: null,
        socso_contact_id: null,
        socso_account_id: null,
        pcb_switch: false,
        pcb_date: null,
        pcb_contact_id: null,
        pcb_account_id: null,
        zakat_switch: false,
        zakat_date: null,
        zakat_contact_id: null,
        zakat_account_id: null,
    },
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.PAYROLL_IMPORT_REQUEST:
            return setRequestReducer(state, 'payrollImportState');
        case actions.PAYROLL_IMPORT_SUCCESS:
            return setSuccessReducer(state, 'payrollImportState', {
                // payroll: action.payroll,
            });

        default:
            return state;
    }
}
